<template>
  <div class="simple-keyboard"></div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import SimpleKeyboard from "simple-keyboard";

export default defineComponent({
  name: "Keyboard",
  emits: ["onChange"],
  props: {
    allowDecimals: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    let kb: SimpleKeyboard;
    const kbLastRowLayout = props.allowDecimals
      ? ". 0 {backspace}"
      : "0  {backspace}";
    onMounted(() => {
      kb = new SimpleKeyboard({
        onChange: (input) => emit("onChange", input),
        layout: {
          default: ["1 2 3", "4 5 6", "7 8 9", kbLastRowLayout],
        },
        display: {
          "{backspace}": "⌫",
          "{enter}": "↵",
        },
        inputName: "amount",
        theme: "hg-theme-default hg-layout-numeric numeric-theme",
        mergeDisplay: true,
      });
    });

    const setInput = (newInput: string) => {
      try {
        if (kb.getInput()) {
          kb.replaceInput({ amount: newInput });
        }
      } catch (error) {
        console.log(error);
      }
    };

    return {
      setInput,
    };
  },
});
</script>

<style>
@import "https://cdn.jsdelivr.net/npm/simple-keyboard@latest/build/css/index.css";
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.light-text {
  color: $pj_color-cool-gray;
}

.disabled-button {
  opacity: 0.5;
}

/*
  Theme: numeric
*/
.numeric-theme {
  max-width: 100%;
  margin: 0 auto;
}

.numeric-theme + .simple-keyboard-preview {
  max-width: 100%;
}

.simple-keyboard.hg-theme-default.numeric-theme.hg-button.hg-standardBtn.hg-button-at {
  max-width: none;
}
</style>
